import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {errorMessage, flashMessage} from 'shared/actions/notifications';
import Loading from 'shared/components/loading';
import Checkbox from 'shared/components/checkbox';
import SimpleTable from 'src/components/SimpleTable';
import ScheduledReportSettingService, {
  ScheduledReportSetting,
} from 'src/services/scheduled-report-setting-service';
import styles from './styles.module.scss';

const columns = [{value: 'Report Name'}, {value: 'Search Type'}, {value: 'Active'}];

const AdminScheduledReports = () => {
  const [reports, setReports] = useState<ScheduledReportSetting[]>([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    ScheduledReportSettingService.index()
      .then(setReports)
      .catch(() => dispatch(errorMessage('Failed to load scheduled reports')))
      .finally(() => setLoading(false));
  }, [dispatch]);

  const toggleActive = async (report: ScheduledReportSetting) => {
    const updated = await ScheduledReportSettingService.update(report.id, {
      active: !report.active,
    });
    setReports((previousReports) =>
      previousReports.map((previousReport) =>
        previousReport.id === report.id ? {...previousReport, ...updated} : previousReport
      )
    );
    dispatch(flashMessage(`"${report.filename}" ${updated.active ? 'activated' : 'deactivated'}`));
  };

  if (loading) return <Loading />;

  const rows = reports.map((report) => [
    {value: report.filename},
    {value: report.studentSearchType},
    {
      value: (
        <Checkbox
          checked={report.active}
          onChange={() => toggleActive(report)}
          label=""
          className={styles.inlineCheckbox}
        />
      ),
    },
  ]);

  return (
    <div>
      <h1 className="shared-font headline">Scheduled Reports</h1>
      <p className="shared-font body">
        Toggle scheduled reports on or off. Inactive reports will not appear in the Report
        Integrations tab and will not trigger file distribution.
      </p>
      <SimpleTable>
        <SimpleTable.Header columns={columns} />
        <SimpleTable.Body
          rows={rows}
          emptyState={{numberOfColumns: 3, text: 'No scheduled reports found'}}
        />
      </SimpleTable>
    </div>
  );
};

export default AdminScheduledReports;
